import { render, staticRenderFns } from "./WidgetBonuses.vue?vue&type=template&id=01c61b3e"
import script from "./WidgetBonuses.vue?vue&type=script&lang=js"
export * from "./WidgetBonuses.vue?vue&type=script&lang=js"
import style0 from "./WidgetBonuses.vue?vue&type=style&index=0&id=01c61b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports